// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2ZTbK","productName":"Table_productName__3bntW"};